import HCRender from "aldoo-ra/HelpCenter/hc-render"

const HomePage = () => {
  const FeaturedContent = HCRender.getFragment("FeaturedContent")
  const RequestLink = HCRender.getFragment("RequestLink")

  return (
    <div className="w-full pt-6 md:pt-14 pb-[112px]">
      {FeaturedContent && <FeaturedContent />}
      <div className="mt-8 md:mt-20 mx-auto">
        {RequestLink && <RequestLink />}
      </div>
    </div>
  )
}

export default HomePage
